import type { ComponentProps } from "react";
import ListDate from "./list-date";
import ListArrow from "./list-arrow";
import ListGroup from "./list-group";
import ListLock from "./list-lock";
import ListCancel from "./list-cancel";
import ListUser from "./list-user";
import ListCheck from "./list-check";

export type ListItemIconName =
  | "date"
  | "arrow"
  | "group"
  | "user"
  | "lock"
  | "cancel"
  | "check";

type ListItemIconProps = {
  name: ListItemIconName;
} & ComponentProps<"svg">;

const ListItemIcon = ({ name, ...props }: ListItemIconProps) => {
  switch (name) {
    case "date":
      return <ListDate {...props} />;
    case "arrow":
      return <ListArrow {...props} />;
    case "group":
      return <ListGroup {...props} />;
    case "lock":
      return <ListLock {...props} />;
    case "user":
      return <ListUser {...props} />;
    case "cancel":
      return <ListCancel {...props} />;
    case "check":
      return <ListCheck {...props} />;
  }
};

export { ListItemIcon };
